import { BroadcastChannel } from 'broadcast-channel';

export const createBroadCastChannel = (channelName: string) => {
  const channel = new BroadcastChannel(channelName);

  return channel;
};
